<template src="./Detalhe.html"></template>
<style lang="scss" scoped src="./Detalhe.scss"></style>

<script>
import service from '../../../services/qrcode.service';
import * as helper from '../helper';
import QrcodeVue from 'qrcode.vue'
import { types } from '../../../store';
export default {
  name: 'bilhete-especial-detalhe',
  props:{
    data:{
      type: Object
    },
  },
  components: {
    QrcodeVue
  },
  data() {
    return {
      loaded: false,
      processing: false,
      dataUrl: null,
      service,
      helper,
      canvasImageOld: null,
      config: {
        size: 256,
        level: 'M',
        padding: 20,
        class: 'qrcode-bilhete'
      }
    }
  },
  computed: {
    current() {
      return this.$store.state.qrcode_current || null;
    },
    item () {
      return this.$store.state.qrcode_detalhe || null;
    },
  },
  methods: {
    fillImage() {
      const canvasOriginal = this.$refs.biqrcode.$vnode.elm.querySelector("canvas");
      if(this.canvasImageOld != canvasOriginal.toDataURL()) {
        this.canvasImageOld = canvasOriginal.toDataURL();
        const padding = this.config.padding;
        const novaLargura = canvasOriginal.width + padding * 2;
        const novaAltura = canvasOriginal.height + padding * 2;

        const canvasComPadding = document.createElement('canvas');
        canvasComPadding.width = novaLargura;
        canvasComPadding.height = novaAltura;
        const contextoComPadding = canvasComPadding.getContext('2d');

        contextoComPadding.fillStyle = 'white'; // Cor do "padding"
        contextoComPadding.fillRect(0, 0, novaLargura, novaAltura);

        contextoComPadding.drawImage(canvasOriginal, padding, padding);

        const dataURL = canvasComPadding.toDataURL();

        this.dataUrl = dataURL;
      }
    },
    gerarPdf() {
      this.processing = true;
      service.getQRCodePDF(this.item.qrcode, this.dataUrl).then((response) => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `bilhete-${ this.item.qrCodeId.replace(/\./gmi,'') }.pdf`; // Nome do arquivo para download
        a.click();
        window.URL.revokeObjectURL(url);
      }).catch((err) => {
        this.$store.dispatch(types.MODAL_ALERT, { dialog: true, title: "Erro", message: "Não foi possivel baixar o PDF do bilhete: " + err });
      }).finally(() => {
        this.processing = false;
      });
    }
  },
  mounted(){
    if(!this.current || !this.item) {
      this.$router.push({ name: 'home' });
      return;
    }
    this.fillImage();
  }
}
</script>
